import { render, staticRenderFns } from "./AnnualCheckup.vue?vue&type=template&id=33920f90&scoped=true"
import script from "./AnnualCheckup.vue?vue&type=script&lang=js"
export * from "./AnnualCheckup.vue?vue&type=script&lang=js"
import style0 from "./AnnualCheckup.vue?vue&type=style&index=0&id=33920f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33920f90",
  null
  
)

export default component.exports